export default __webpack_public_path__ + "assets/sounds/2f23dad1aa98327bfd19d3e02e719d2a.mp3";